module.exports = __webpack_public_path__ + "media/images/redrock/hero-image-corona-small-5121d5a008a3b8c508c75d83e87e1a9c.jpg";